import { HYDRATE } from 'next-redux-wrapper';

import {
    SET_BANNERS_FOR_MAIN_PAGE,
    SET_PROMO_BANNER_FOR_MAIN_PAGE,
    SET_PROMO_DOUBLE_BANNERS_FOR_MAIN_PAGE,
} from '../actionTypes/main';

const initialState = {
    banners: [],
    mainPromoBanner: {},
    mainPromoDoubleBanners: [],
};

export default (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case HYDRATE:
            return { ...state, ...action.payload.main };
        case SET_BANNERS_FOR_MAIN_PAGE:
            return ({
                ...state,
                banners: [...payload],
            });
        case SET_PROMO_BANNER_FOR_MAIN_PAGE:
            return ({
                ...state,
                mainPromoBanner: [...payload],
            });
        case SET_PROMO_DOUBLE_BANNERS_FOR_MAIN_PAGE:
            return ({
                ...state,
                mainPromoDoubleBanners: [...payload],
            });
        default:
            return state;
    }
};
